<ion-row>
  <div class="join-poup-wrapper">
    <div class="shadow-1"></div>
    <div class="shadow-2"><img class="img-1" src="../../../../assets/icon/backShadow-1.png" alt="" /></div>
    <div class="success-ic-wrap ion-text-center">
      <div class="greeting-icon">
        <img src="../../../../assets/icon/imog-icon.png" alt="" />
      </div>
    </div>
    <p class="success-msg">Great!</p>
    <p class="joined-label">
      <span>You can now help to contribute...</span> <br />
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam nisi metus, ornare a vestibulum eget, gravida
      vitae velit.
    </p>
    <p class="close" (click)="close()">{{ "joined-syndicate.Close" | translate }}</p>
  </div>
</ion-row>